import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import { useWallet, Wallet } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import styled from 'styled-components';

import theme, {bp, color} from 'settings/theme';

const WalletMultiButton = dynamic(
  async () => (await import('@solana/wallet-adapter-react-ui')).WalletMultiButton,
  { ssr: false }
);

type Props = {
  children(passProps: { 
    connecting: boolean, 
    connected: boolean, 
    shortAddress?: string,
    wallet: Wallet | null
  }): ReactElement
}

const ConnectWalletButton: React.FC<Props> = (props) => {

  const [isMounted, setIsMounted] = useState(false);

  const { connected, connecting, publicKey, wallet } = useWallet();

  // Short Address
  const shortAddress = useMemo(() => {
    const longAddress = !!publicKey ? publicKey?.toBase58() : null;
    if (!longAddress) return;
    if (longAddress.length < 10) return longAddress;
    return longAddress.slice(0, 4) + '...' + longAddress.slice(-4);
  }, [publicKey]);

  // Connection Successful
  useEffect(() => {
    if (connected && isMounted) {
      // Wallet Connected
    }
    else if (!isMounted) {
      setIsMounted(true);
    }
  }, [connecting, connected, isMounted]);


  return (
    <WalletModalProvider>
      <StyledWalletButton>
        {props.children({connecting, connected, shortAddress, wallet})}
      </StyledWalletButton>
    </WalletModalProvider>
  );

};

export default ConnectWalletButton;

const StyledWalletButton = styled(WalletMultiButton)<typeof WalletMultiButton>`
  
  // Defaults
  --height: var(--connect-wallet-button-height, 2rem);
  --text-color: var(--connect-wallet-button-text-color, 'white');
  --font-size: var(--connect-wallet-button-font-size, 0.75rem);
  --bg-color: var(--connect-wallet-button-color, ${color.gray(50)});
  --hover-bg-color: var(--connect-wallet-button-hover-color, ${color.gray(60)});
  --border-radius: var(--connect-wallet-button-border-radius, 0.5rem);

  width: auto;
  height: var(--height);
  padding: 0 1rem;
  color: var(--text-color);
  font-family: ${theme.typography.fontFamilyDefault};
  font-size: var(--font-size);
  line-height: var(--height);
  border-radius: var(--border-radius);
  background-color: var(--bg-color) !important;
  transition: background-color 0.15s ease-out;

  &:hover{
    background-color: var(--hover-bg-color) !important;
  }

  .wallet-adapter-button-start-icon,
  .wallet-adapter-button-end-icon{
    display: none;
  }

`;